import { render } from "./WhySogdoItsCoreValuesComp.vue?vue&type=template&id=1acf654f&scoped=true"
import script from "./WhySogdoItsCoreValuesComp.vue?vue&type=script&lang=js"
export * from "./WhySogdoItsCoreValuesComp.vue?vue&type=script&lang=js"

import "./WhySogdoItsCoreValuesComp.vue?vue&type=style&index=0&id=1acf654f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acf654f"]])

export default __exports__